import {
  FaCode,
  FaMobileAlt,
  FaCloud,
  FaPalette,
  FaBuilding,
  FaGlobe,
} from "react-icons/fa";
import "./HomeInternalLinks.css";

const HomeInternalLinks = () => {
  return (
    <section
      className="oglitz-home-capabilities"
      aria-labelledby="oglitz-capabilities-title"
    >
      <div className="oglitz-home-capabilities__inner">
        <span className="oglitz-home-capabilities__badge">
          Explore Our Capabilities
        </span>

        <h2 id="oglitz-capabilities-title">
          End-to-End Digital Solutions for Modern Businesses
        </h2>

        <p className="oglitz-home-capabilities__desc">
          <strong>Oglitz Software</strong> delivers scalable and secure digital
          solutions including <a href="/services">Web Development</a>,{" "}
          <a href="/services">Mobile App Development</a>,{" "}
          <a href="/services">SaaS Solutions</a>,{" "}
          <a href="/services">UI/UX Design</a>, and{" "}
          <a href="/services">Enterprise Software Development</a> — helping
          startups, enterprises, and global brands build future-ready products.
        </p>

        <ul className="oglitz-home-capabilities__tags">
          <li>
            <FaCode /> Web Applications
          </li>
          <li>
            <FaMobileAlt /> Mobile Apps
          </li>
          <li>
            <FaCloud /> SaaS Platforms
          </li>
          <li>
            <FaPalette /> UI / UX Design
          </li>
          <li>
            <FaBuilding /> Enterprise Software
          </li>
        </ul>

        <div className="oglitz-home-capabilities__location">
          <FaGlobe />
          <span>India · Dubai · Global Delivery</span>
        </div>
      </div>
    </section>
  );
};

export default HomeInternalLinks;
